export default "__VITE_ASSET__e8769a3a__"